import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import { setYupLocale } from '../helpers/YupHelpers'

import fr from './fr.json'

export const resources = {
  fr,
} as const

// i18next 26 removed `interpolation.format`; formatting is now done via the
// formatter service (i18n.services.formatter.add). No translation in fr.json
// uses the `{{value, format}}` syntax, so the previous custom formatter was
// dead code and is dropped. Re-add named formatters here if needed later.
i18n.use(initReactI18next).init({
  resources,
  lng: 'fr',
  interpolation: {
    escapeValue: false,
  },
})

setYupLocale(i18n)

i18n.on('languageChanged', () => {
  setYupLocale(i18n)
})

export default i18n
